module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Bell-1635f0536f9f941d63ef8c4dfc4acd41.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Bell.mp3
// module id = 64
// module chunks = 0